<template>
  <div class="knowledge">
    <viewHeader></viewHeader>
    <div
      class="content"
      v-loading.fullscreen="loading"
      element-loading-text="拼命加载中"
    >
      <el-card class="box-card" shadow="never" v-show="isShow">
        <div slot="header" class="clearfix">
          <img src="../assets/img/medical.png" alt="" class="L" />
          <span class="L"
            >{{ drug_key }}<br /><em>为您找到 {{ totalNum }} 篇文献</em></span
          >
        </div>
        <div class="introduce">
          <h2 class="title clearfix">
            <span class="L"></span><em class="L">简介</em>
          </h2>
          <p class="info">{{ drugInfo.overview }}</p>
        </div>
        <div class="introduce medInfo">
          <h2 class="title clearfix">
            <span class="L"></span><em class="L">更多信息</em>
          </h2>
          <el-row class="info">
            <el-col
              :span="key === '药物靶点' ? 24 : 12"
              v-for="(value, key) in drugInfo.more_info"
              :key="key"
            >
              <p>
                <span>{{ key }}：</span><em>{{ value }}</em>
              </p>
            </el-col>
          </el-row>
        </div>
        <div class="introduce">
          <h2 class="title clearfix">
            <span class="L"></span><em class="L">相关信息搜索</em>
          </h2>
          <el-tabs type="border-card">
            <el-tab-pane
              :label="key"
              v-for="(value, key) in checkInfo"
              :key="key"
            >
              <span slot="label" style="position: relative">
                {{ key }}
                <!-- <el-badge :value="12" class="badge-a"/> -->
              </span>
              <el-row>
                <el-col :span="6" v-for="(item, index) in value" :key="index">
                  <el-checkbox
                    v-model="item.ischecked"
                    :label="item.name"
                    @change="checkBox(item.name, item.ischecked)"
                    >{{ item.name }}</el-checkbox
                  >
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
          <p class="checkBtn">
            <em class="el-icon-circle-check" @click="drugSearch()"></em>
            <em class="el-icon-circle-close" @click="clearCheck()"></em>
          </p>
        </div>
        <el-card class="box-card" shadow="never">
          <div class="keyWord">
            <el-row>
              <el-col :span="20" class="diseaseList">
                {{ drug_key }} {{ scope.join("/") }}
              </el-col>
              <el-col :span="4">
                <el-button
                  class="R"
                  size="small"
                  style="padding: 3px 0"
                  type="text"
                  @click="analysis"
                  >文献总结</el-button
                >
              </el-col>
            </el-row>
          </div>
          <div class="resultTtle">
            <el-row :gutter="40">
              <el-col :span="5" class="num"
                >共为您找到<span> {{ totalNum }} </span>篇文献</el-col
              >
              <el-col :span="19">
                <el-col :span="4" style="cursor: pointer; padding: 0">
                  <el-dropdown trigger="click" @command="handleCommand($event,true)">
                    <span class="el-dropdown-link">
                      文献类型<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in pubType"
                        :key="index"
                        :command="{ value: item, name: 'pubType' }"
                        >{{ item }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
                <el-col :span="4" style="cursor: pointer; padding: 0">
                  <el-dropdown trigger="click" @command="handleCommand($event,false)">
                    <span class="el-dropdown-link">
                      发表时间<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in pubDate"
                        :key="index"
                        :command="{ value: item, name: 'pubDate' }"
                      >
                        <span v-if="item === '全部'">{{ item }}</span>
                        <span v-else-if="item !== '全部'">近{{ item }}年</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
                <el-col :span="4" style="cursor: pointer; padding: 0">
                  <el-dropdown trigger="click" @command="handleCommand($event,true)">
                    <span class="el-dropdown-link">
                      影响因子<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in impFct"
                        :key="index"
                        :command="{ value: item, name: 'impFct' }"
                        >{{ item }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
                <el-col
                  :span="7"
                  style="cursor: pointer; margin-top: -4px; padding: 0"
                >
                  <!-- <el-dropdown trigger="click"  @command="handleCommandSort">
                                        <span class="el-dropdown-link">
                                            相关性排序<i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-for="(item, index) in sort" :key="index" :command="{ 'value': item, 'name': 'sort' }">{{ item }}</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown> -->
                  <span class="L sort_sp">排序</span>
                  <el-select
                    v-model="sortText"
                    placeholder="请选择"
                    size="small"
                    @change="handleCommandSort"
                    class="L"
                  >
                    <el-option
                      v-for="(item, index) in sort"
                      :key="index"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <!-- <el-col :span="4" class="R">
                                    <el-checkbox v-model="manual" @change="change">只看人工标注</el-checkbox>
                                </el-col> -->
              </el-col>
            </el-row>
          </div>
          <div class="tags">
            <el-row>
              <el-col :span="20">
                <el-tag
                  closable
                  v-for="(tag, tagIndex) in tags"
                  :key="tagIndex"
                  @close="closeTags(tag, tagIndex)"
                >
                  {{ tag }}
                </el-tag>
              </el-col>
              <el-col
                :span="4"
                class="clearfix clearBtn"
                v-if="tags.length !== 0"
              >
                <el-link type="primary" class="R" @click="clearFilter"
                  >清空筛选条件</el-link
                >
                <img src="../assets/img/clear.png" alt="" class="R" />
              </el-col>
            </el-row>
          </div>
          <div
            class="resultList"
            v-loading="loading2"
            element-loading-text="拼命加载中"
          >
            <ul>
              <li
                v-for="(item, index) in searchData"
                :key="index"
                v-loading="item.loading"
              >
                <el-row :gutter="20" class="listTitle">
                  <el-col :span="14" class="title">
                    {{ item.title_en }}
                    <img v-show="item.is_download" class="pptIcon" src="../assets/img/ppt.png" alt="">
                  </el-col>
                  <el-col
                    :span="5"
                    class="YXYZ clearfix"
                    v-if="item.impact_factor && item.impact_factor !== ''"
                  >
                    <img src="../assets/img/icon6.png" alt="" class="L" />
                    <span class="L">影响因子：{{ item.impact_factor }}</span>
                  </el-col>
                  <el-col
                    :span="5"
                    class="RGBZ clearfix"
                    v-if="item.has_manual_curation !== 0"
                  >
                    <img src="../assets/img/icon5.png" alt="" class="L" />
                    <span class="L"
                      >人工标注：{{ item.has_manual_curation }}</span
                    >
                  </el-col>
                </el-row>
                <div class="tags" style="marginTop: 10px">
                  <articleTags :pubdate="item.pubdate_show" :language="item.language" :pubType="item.pub_type"></articleTags>
                </div>
                <el-row class="listInfo">
                  <el-col :span="10"><span>PMID：</span>{{ item.pmid }}</el-col>
                  <el-col :span="10" v-if="item.doi"><span>DOI：</span>{{ item.doi }}</el-col>
                  <el-col :span="20"
                    ><span>期刊：</span>{{ item.journal_name }}</el-col
                  >
                  <!-- <el-col :span="20"
                    ><span>发表时间：</span>{{ item.pubdate_show }}</el-col
                  > -->
                  <el-col
                    :span="20"
                    v-if="
                      item.keyword_categories &&
                      item.keyword_categories['Diseases']
                    "
                  >
                    <span>疾病：</span>
                    <em
                      v-for="(disease, disIndex) in item.keyword_categories[
                        'Diseases'
                      ]"
                      :key="disIndex"
                      >{{ disease[0] + "(" + disease[1] + ")"
                      }}<i
                        v-if="
                          disIndex + 1 <
                          item.keyword_categories['Diseases'].length
                        "
                      >
                        、</i
                      ></em
                    >
                  </el-col>
                  <el-col
                    :span="20"
                    v-if="
                      item.keyword_categories &&
                      item.keyword_categories['Drugs and Chemicals']
                    "
                  >
                    <span>药品：</span>
                    <em
                      v-for="(drug, drugIndex) in item.keyword_categories[
                        'Drugs and Chemicals'
                      ]"
                      :key="drugIndex"
                      >{{ drug[0] + "(" + drug[1] + ")"
                      }}<i
                        v-if="
                          drugIndex + 1 <
                          item.keyword_categories['Drugs and Chemicals'].length
                        "
                      >
                        、</i
                      ></em
                    >
                  </el-col>
                  <el-col
                    :span="20"
                    v-if="
                      item.keyword_categories &&
                      item.keyword_categories['Geographic Locations']
                    "
                  >
                    <span>地理位置：</span>
                    <em
                      v-for="(location, locationIndex) in item
                        .keyword_categories['Geographic Locations']"
                      :key="locationIndex"
                      >{{ location[0] + "(" + location[1] + ")"
                      }}<i
                        v-if="
                          locationIndex + 1 <
                          item.keyword_categories['Geographic Locations'].length
                        "
                      >
                        、</i
                      ></em
                    >
                  </el-col>
                  <el-col :span="20" v-if="item.key_information">
                    <span>重点信息：</span>
                    <div :class="item.key_height">
                      <p class="key_infor" v-for="(important, importantIndex) in item.important_message" :key="'重点信息' + importantIndex">
                        {{ `● ${important}` }}
                      </p>
                      <!-- <p
                        class="key_infor"
                        v-if="
                          item.key_information[0] &&
                          item.key_information[0][1] !== ''
                        "
                      >
                        <span>研究背景：</span>{{ item.key_information[0][1] }}
                      </p>
                      <p
                        class="key_infor"
                        v-if="
                          item.key_information[1] &&
                          item.key_information[1][1] !== ''
                        "
                      >
                        <span>研究目的：</span>{{ item.key_information[1][1] }}
                      </p>
                      <p
                        class="key_infor"
                        v-if="
                          item.key_information[4] &&
                          item.key_information[4][1] !== ''
                        "
                      >
                        <span>研究结论：</span>{{ item.key_information[4][1] }}
                      </p> -->
                    </div>
                    <em
                      class="R down"
                      :class="
                        item.key_height === 'initHeight'
                          ? 'el-icon-arrow-down'
                          : 'el-icon-arrow-up'
                      "
                      @click="showFull(item.key_height, index)"
                    ></em>
                    <!-- <button class="R down" @click="showFull(item.key_height, index)">{{ item.key_height === 'initHeight' ? '展开' : '收起'}}</button> -->
                  </el-col>
                </el-row>
                <div class="action">
                  <a
                    href="javascript:;"
                    class="translate"
                    @click="translateFullText(item.pmid, index, item.translate)"
                    title="翻译"
                  >
                    <!-- <img src="../assets/img/icon1.png" alt="" class="translate"> -->
                  </a>
                  <a
                    href="javascript:;"
                    class="fullText"
                    @click="showFullText(item.pmid)"
                    title="查看全文"
                  >
                    <!-- <img src="../assets/img/icon2.png" alt="" class="fullText"> -->
                  </a>
                  <a
                    href="javascript::"
                    :class="item.is_collected ? 'collectionTrue' : 'collection'"
                    @click="collection(item.pmid, item.is_collected, index)"
                    title="收藏"
                  >
                    <!-- <img src="../assets/img/icon3.png" alt="" class="collection"> -->
                  </a>
                  <!-- <a href="javascript:;" class="share" title="分享"> -->
                  <!-- <img src="../assets/img/icon4.png" alt="" class="share"> -->
                  <!-- </a> -->
                </div>
              </li>
            </ul>
          </div>
          <el-pagination
            v-show="isShow"
            background
            :hide-on-single-page="true"
            :current-page="pageNum"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="totalNum"
          >
          </el-pagination>
        </el-card>
      </el-card>
      <div class="noData" v-show="!hasData">
        <img src="../assets/img/empty.png" alt="" />
        <span>空空如也，重新搜搜看看吧~</span>
      </div>
    </div>
  </div>
</template>

<script>
import { md5 } from "md5js";
import viewHeader from "./viewHeader";
import articleTags from '../components/articleTags'
import {
  drugSearch,
  getFilters,
  translateInfo,
  collection,
} from "../service/getData";
import { webTrackerEvent } from "../utils/tracker";
export default {
  name: "knowledge",
  components: {
    viewHeader,
    articleTags
  },
  data() {
    return {
      hasData: true,
      secret: "4ede4aafbzd51cbz3e32bzb781bzee9813d17154",
      clientId: "zeta",
      loading: true,
      loading2: false,
      isShow: false,
      keyword: "", // 关键字
      searchData: [], // 搜索出的文献数据
      drugInfo: {}, // 药物简介
      pageNum: 1, // 当前页
      pageSize: 10, // 每页数量
      totalNum: 0, // 搜索出的总数
      isShow: false,
      pubType: [], // 文献类型
      pubDate: [], // 发表时间
      impFct: [], // 影响因子
      sort: [], // 相关性排序
      manual: false, // 是否是人工标注
      filter: {
        pubType: [],
        pubDate: [],
        impFct: [],
        manual: "",
      }, // 筛选条件
      sortText: "相关性从高到低",
      titleJson: {},
      importantJson: {}, // 重点信息
      checkInfo: {}, //
      scope: [],
      searchType: "", // 搜索的类型， 疾病还是药品
      isFirst: true, // 是否是第一次加载
      tags: [], // 过滤条件
      tagsJson: {},
      drug_key: "", // 如果是药品搜索，title显示中文 空格 英文
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
    };
  },
  methods: {
    // 获取搜索结果
    async drugSearch() {
      this.loading2 = true;
      const params = {
        keyword: this.keyword,
        scope: this.scope,
        filters: {
          manual: this.filter.manual,
          pubType: this.filter.pubType.join('|'),
          impFct: this.filter.impFct.join('|'),
          pubDate: this.filter.pubDate[0] || ''
        },
        sort: this.sortText,
        pages: {
          limit: this.pageSize,
          page: this.pageNum,
        },
      };
      const res = await drugSearch(params);

      let Logger = webTrackerEvent();
      if (this.searchType === "disease") {
        Logger.push("search_kind", "disease");
      } else {
        Logger.push("search_kind", "drug");
      }
      Logger.push("search_type", "normal");
      Logger.push("page_url", window.location.href);
      Logger.push("action", "search");
      Logger.push("search_keyword", this.keyword);
      Logger.push("search_filter", JSON.stringify(this.filter));
      Logger.push("search_sort", this.sortText);
      Logger.push("search_scope", this.scope);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if ((res && res.data.status == 0) || (res && res.data.status == 2)) {
        this.drugInfo = res.data.drug_info;
        this.loading = false;
        this.loading2 = false;
        this.isShow = true;
        this.hasData = true;
        // 文献搜索结果
        this.drug_key =
          res.data.drug_info["name"][1] + " " + res.data.drug_info["name"][0];

        if (res.data.data && res.data.data.length != 0) {
          this.totalNum = res.data.numFound;
          res.data.data.forEach((item, index) => {
            if (item.pubdate_show) {
              // item.pubdate_show = item.pubdate_show.substring(0, 10);
              item.loading = false;
            }
            item.key_height = "initHeight";
            item.translate = false;
            this.titleJson[index] = item.title_en;
            this.importantJson[index] = item.important_message;
          });
          this.searchData = res.data.data;
        } else {
          this.totalNum = 0;
          this.searchData = [];
        }

        // 相关信息搜索内容
        if (!this.isFirst) return;
        this.isFirst = false;
        for (const name in this.drugInfo["for_search"]) {
          this.$set(this.checkInfo, name, []);
          this.drugInfo["for_search"][name].forEach((item) => {
            this.checkInfo[name].push({ name: item[1], ischecked: false });
          });
        }
      }
      // else if (res.data.status === 1){
      //     this.loading = false
      //     this.loading2 = false
      //     this.isShow = false
      //     this.searchData = []
      //     this.totalNum = 0
      //     this.hasData = false
      // }
      else {
        this.loading = false;
        this.loading2 = false;
        this.searchData = [];
        this.totalNum = 0;
        this.isShow = false;
        this.hasData = false;
      }
    },
    // 获取筛选条件
    async getFilterOpt() {
      const res = await getFilters();
      if (res && res.data.status === 0) {
        this.pubType = ["全部", ...res.data.data.pubType];
        this.pubDate = ["全部", ...res.data.data.pubDate];
        this.impFct = ["全部", ...res.data.data.impFct];
        this.sort = res.data.data.sort;
      }
    },
    // 筛选条件
    handleCommand(command,multiple) {
      const {value,name} = command;
      const selectedList = this.tagsJson[name];
      
      if(selectedList) {
        const isExist = selectedList.find(item => item == value);
        if(isExist) {
          return;
        }
      } else if(value == '全部') {
        return;
      }

      
      // 修改过滤条件
      if (command.value === "全部") {
        this.filter[command.name] = [];
      } else {
        if(multiple) {
          this.filter[command.name].push(command.value);
        } else {
          this.filter[command.name] =  [command.value];
        }
      }

      // 获取过滤条件 标签显示
      if (command.name === "pubDate") {
        if (command.value !== "全部") {
          if(multiple) {
            this.tagsJson[command.name] ? this.tagsJson[command.name].push("近" + command.value + "年") : this.tagsJson[command.name] = ["近" + command.value + "年"];
          } else {
            this.tagsJson[command.name] = ["近" + command.value + "年"];
          }
        } else {
          delete this.tagsJson["pubDate"];
        }
      } else {
        if (command.value !== "全部") {
          if(multiple) {
            this.tagsJson[command.name] ? this.tagsJson[command.name].push(command.value) : this.tagsJson[command.name] = [command.value];
          } else {
            this.tagsJson[command.name] = [command.value];
          }
        } else {
          delete this.tagsJson[command.name];
        }
      }
      this.tags = [];
      for (const name in this.tagsJson) {
        this.tags.push(...this.tagsJson[name]);
      }
      this.loading2 = true;
      this.pageNum = 1;
      this.drugSearch();
    },
    // 关闭标签
    closeTags(tag, tagIndex) {
      for (const name in this.tagsJson) {
        const selectedList = this.tagsJson[name];
        const index = selectedList.findIndex(item => item == tag);
        
        if(index > -1) {
          selectedList.splice(index,1);
          const filterIndex = this.filter[name].findIndex(item => {
            if(name == 'pubDate') {
              return `近${item}年` == tag;
            } else {
              return item == tag;
            }
          });
          if(filterIndex > -1) {
            this.filter[name].splice(filterIndex,1);
          }
          break;
        }
      }
      this.tags.splice(tagIndex, 1);
      if (this.tags.length === 0) {
        this.tagsJson = {};
      }
      this.loading2 = true;
      this.pageNum = 1;
      this.drugSearch();
    },
    // 清除筛选条件
    clearFilter() {
      this.tags = [];
      this.tagsJson = {};
      this.filter["pubType"] = [];
      this.filter["pubDate"] = [];
      this.filter["impFct"] = [];
      this.loading2 = true;
      this.pageNum = 1;
      this.drugSearch();
    },
    // 排序条件
    handleCommandSort() {
      this.loading2 = true;
      this.pageNum = 1;
      this.drugSearch();
    },
    // 选择人工标注
    change(val) {
      if (val) {
        this.filter["manual"] = 1;
      } else {
        this.filter["manual"] = "";
      }
      this.loading2 = true;
      this.pageNum = 1;
      this.drugSearch();
    },
    // 分页
    handleCurrentChange(val) {
      this.loading2 = true;
      this.pageNum = val;
      window.scroll(0, 0);
      this.drugSearch();
    },
    // 翻译重点信息
    async translateFullText(pmid, index, translate) {
      this.searchData[index].loading = true;
      let key_type = "";
      if (translate) {
        this.searchData[index].title_en = this.titleJson[index];
        this.searchData[index].important_message = this.importantJson[index];
        key_type = "en_key";
      } else {
        key_type = "cn_key";
      }
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${pmid}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(pmid),
        types: key_type,
        token: token,
      };
      const res = await translateInfo(params);

      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "translate");
      Logger.push("language", key_type);
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (res.data.status == 0) {
        if (!translate) {
          this.searchData[index].title_en = res.data.data.title;
          this.searchData[index].key_information = res.data.data.sentence;
          this.searchData[index].important_message = res.data.data.important_message;
          this.searchData[index].translate = true;
          this.searchData[index].loading = false;
          return;
        }
        this.searchData[index].key_information = res.data.data.sentence;
        this.searchData[index].translate = false;
        this.searchData[index].loading = false;
      }
    },
    // 展开全文
    showFull(key_height, index) {
      if (key_height === "initHeight") {
        this.searchData[index]["key_height"] = "autoHeight";
      } else {
        this.searchData[index]["key_height"] = "initHeight";
      }
    },
    // 收藏还是取消收藏
    collection(pmid, collect, index) {
      if (!collect) {
        let Logger = webTrackerEvent();
        Logger.push("page_url", window.location.href);
        Logger.push("action", "collection");
        Logger.push("pmid", pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        collection("POST", { pmid: pmid }).then((res) => {
          if (res.data.status === 0) {
            this.searchData[index].is_collected = true;
          } else {
            this.$message({
              message: "收藏失败，请重试",
              type: "error",
            });
          }
        });
      } else {
        let Logger = webTrackerEvent();
        Logger.push("page_url", window.location.href);
        Logger.push("action", "delete_collection");
        Logger.push("pmid", pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        collection("DELETE", { pmid: pmid }).then((res) => {
          if (res.data.status === 0) {
            this.searchData[index].is_collected = false;
          } else {
            this.$message({
              message: "取消失败，请重试",
              type: "error",
            });
          }
        });
      }
    },
    // 查看全文
    showFullText(pmid) {
      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "fullText");
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      const { href } = this.$router.resolve({
        name: "fullText",
        path: "/fullText",
        query: {
          pmid: pmid
        },
      });
      window.open(href);
      // this.$router.push("fullText?pmid=" + pmid);
    },
    // 相关信息选择后搜索
    checkBox(val, check) {
      if (check) {
        this.scope.push(val);
      } else {
        this.scope.forEach((item, index) => {
          if (item === val) {
            this.scope.splice(index, 1);
          }
        });
      }
    },
    // 清除所有选项
    clearCheck() {
      for (const name in this.checkInfo) {
        this.checkInfo[name].forEach((item) => {
          item.ischecked = false;
        });
      }
      this.scope = [];
      this.drugSearch();
    },
    // 文献总结
    analysis() {
      let Logger = webTrackerEvent();
      let searchType = "";
      if (this.searchType === "disease") {
        searchType = "disease";
        Logger.push("search_kind", "disease");
      } else {
        searchType = "drug";
        Logger.push("search_kind", "drug");
      }
      const { href } = this.$router.resolve({
        name: "pubMedChart",
        path: "/pubMedChart",
        query: {
          key: this.keyword,
          numFound: this.totalNum,
          filter: JSON.stringify({
            manual: this.filter.manual,
            pubType: this.filter.pubType.join('|'),
            impFct: this.filter.impFct.join('|'),
            pubDate: this.filter.pubDate[0] || ''
          }),
          sort: this.sortText,
          searchType: searchType,
          scope: JSON.stringify(this.scope),
        },
      });

      Logger.push("page_url", window.location.href);
      Logger.push("search_type", "normal");
      Logger.push("action", "pubMedChart");
      Logger.push("search_keyword", this.keyword);
      Logger.push("search_filter", JSON.stringify(this.filter));
      Logger.push("search_sort", this.sortText);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      window.open(href);
    },
  },
  mounted() {
    this.keyword = this.$route.query.key;
    this.searchType = this.$route.query.searchType;
    this.drugSearch();
    this.getFilterOpt();
  },
};
</script>

<style scoped>
.knowledge {
  background: #f9f9f9;
  min-height: 700px;
  padding-bottom: 50px;
}
.knowledge .content {
  width: 1080px;
  margin: 0 auto;
}
.knowledge .content .el-card__header span {
  margin-left: 18px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.knowledge .content .el-card__header span em {
  font-size: 14px;
  color: #333;
  font-weight: normal;
}
.knowledge .content .el-card__header img {
  margin-top: 10px;
}
.content .introduce {
  margin-bottom: 40px;
  position: relative;
}
.content .introduce h2.title {
  font-weight: normal;
  font-size: 16px;
  color: #333;
}
.content .introduce h2.title span {
  width: 6px;
  height: 24px;
  background: #4083d4;
  display: block;
}
.content .introduce h2.title em {
  margin-left: 10px;
  line-height: 24px;
}
.content .introduce .info {
  line-height: 30px;
  margin-top: 10px;
}
.content .medInfo .el-row .el-col {
  line-height: 40px;
  border-bottom: 1px dashed #e2e2e2;
}
.content .medInfo .el-row .el-col span {
  font-weight: bold;
}
.content .medInfo .el-row .diseaseList {
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content .introduce .el-tabs {
  margin-top: 20px;
}
.content .introduce .el-badge {
  top: 0;
}
.knowledge .content .keyWord {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
  line-height: 34px;
}
.knowledge .content .keyWord .el-button {
  padding: 10px 20px !important;
  border: 1px solid #409eff;
}
.knowledge .content .resultTtle {
  font-size: 14px;
  color: #333;
}
.knowledge .content .resultTtle .pointData {
  font-size: 12px;
  color: #eb7400;
  margin-bottom: 5px;
}
.knowledge .content .resultTtle span.sort_sp {
  line-height: 32px;
  margin-right: 10px;
  font-size: 13px;
  color: #606266;
}
.knowledge .content .resultTtle .el-select {
  width: 150px;
  line-height: 32px;
}
.knowledge .content .tags {
  margin-top: 20px;
}
.knowledge .content .tags em {
  font-size: 12px;
  color: #6098db;
}
.knowledge .content .tags span {
  margin-right: 10px;
}
.knowledge .content .tags .clearBtn {
  line-height: 32px;
}
.knowledge .content .tags .clearBtn img {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 10px;
  margin-top: 6px;
}
.knowledge .content .resultTtle .num span {
  font-size: 16px;
  color: #387ed2;
}
.knowledge .content .resultList {
  margin-top: 20px;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-bottom: none;
}
.knowledge .content .resultList ul li {
  border-bottom: 1px solid #ccc;
  padding: 10px;
  position: relative;
  overflow: hidden;
}
.knowledge .content .resultList .listTitle .title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.knowledge .content .resultList .listTitle .title .pptIcon {
  width: 20px;
  vertical-align: middle;
}
.knowledge .content .resultList .listTitle .YXYZ span {
  /* line-height: 30px; */
  margin-left: 10px;
}
.knowledge .content .resultList .listTitle .RGBZ span {
  line-height: 30px;
  margin-left: 10px;
}
.knowledge .content .resultList .listTitle .YXYZ img {
  width: 15px;
  height: 15px;
  margin-top: 2px;
}
.knowledge .content .resultList .listTitle .RGBZ img {
  width: 17px;
  height: 20px;
  margin-top: 5px;
}
.knowledge .content .resultList .listInfo {
  margin-top: 10px;
}
.knowledge .content .resultList .listInfo .el-col {
  margin-bottom: 10px;
}
.knowledge .content .resultList .listInfo .el-col span {
  color: #387ed2;
}
.knowledge .content .resultList .listInfo .initHeight {
  height: 30px;
  overflow: hidden;
}
.knowledge .content .resultList .listInfo em.down {
  margin-top: 5px;
  font-size: 24px;
  position: relative;
  top: -24px;
  right: -60px;
  cursor: pointer;
}
.knowledge .content .resultList .listInfo .autoHeight {
  height: auto;
}
.knowledge .content .resultList .listInfo .el-col .key_infor {
  margin-top: 10px;
  line-height: 25px;
}
.knowledge .content .resultList .action {
  width: 50px;
  height: 100%;
  border-left: 1px solid #ccc;
  position: absolute;
  top: 0;
  right: 0;
  background: #f5f5f5;
  /* padding-top: 26px; */
}
.knowledge .content .resultList .action a {
  display: block;
  height: 33.3%;
}
.knowledge .content .resultList .action a.translate {
  background: url("../assets/img/icon1.png") no-repeat center center;
}
.knowledge .content .resultList .action a.fullText {
  background: url("../assets/img/icon2.png") no-repeat center center;
}
.knowledge .content .resultList .action a.collection {
  background: url("../assets/img/icon3.png") no-repeat center center;
}
.knowledge .content .resultList .action a.collectionTrue {
  background: url("../assets/img/icon3_01.png") no-repeat center center;
}
.knowledge .content .resultList .action a.share {
  background: url("../assets/img/icon4.png") no-repeat center center;
}
.knowledge .content .resultList .action a:hover {
  background-color: #387ed2;
}
.knowledge .content .resultList .action a.translate:hover {
  background-image: url("../assets/img/icon1_01.png");
}
.knowledge .content .resultList .action a.fullText:hover {
  background-image: url("../assets/img/icon2_01.png");
}
.knowledge .content .resultList .action a.collection:hover {
  background-image: url("../assets/img/icon3_02.png");
}
.knowledge .content .resultList .action a.share:hover {
  background-image: url("../assets/img/icon4_01.png");
}
.knowledge .content .el-pagination {
  margin-top: 30px;
  text-align: center;
}
.knowledge .content .checkBtn {
  font-size: 20px;
  position: absolute;
  top: 54px;
  right: 10px;
  cursor: pointer;
  z-index: 22;
}
.knowledge .content .checkBtn em {
  margin-left: 10px;
  color: #2aa3d1;
}
.knowledge .noData {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.knowledge .noData img {
  display: block;
  margin: 0 auto;
}
.knowledge .noData span {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
}
.content .introduce >>> .el-tabs__content .el-checkbox {
  display: flex;
  align-content: center;
}
.content .introduce >>> .el-tabs__content .el-checkbox .el-checkbox__label {
  /* white-space: normal; */
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style>
.content .introduce .el-tabs--border-card > .el-tabs__header {
  background-color: #f5fcff;
  border-bottom-color: #49b1d8;
  margin-left: 1px;
}
.content .introduce .el-tabs--border-card {
  box-shadow: none;
  border: 1px solid #49b1d8;
  border-right: none;
  border-left: none;
  border-top: none;
}
.content
  .introduce
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item.is-active {
  border-right-color: #49b1d8;
  border-left-color: #49b1d8;
  border-top-color: #49b1d8;
  border-bottom: none;
}
.content .introduce .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border-bottom-color: #49b1d8;
  color: #333;
  font-weight: normal;
}
.content .introduce .el-tabs--border-card > .el-tabs__content {
  border-right: 1px solid #49b1d8;
  border-left: 1px solid #49b1d8;
}
.content .introduce .el-tabs__nav {
  float: none;
}
.content .introduce .el-tabs__nav-wrap {
  overflow: visible;
}
.content .introduce .el-tabs__nav-scroll {
  overflow: visible;
}
.content .introduce .el-tabs__nav-scroll {
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// src/views/knowledge.vue